import { createApp, Directive, DirectiveBinding } from 'vue';
import { isObject } from 'lodash';

import { uuid } from '@wittignl/js-core';

import Spinner from '../component/ui/Spinner.vue';

function update(el: HTMLElement, binding: DirectiveBinding): void {

    let containerClass = el.dataset.uiSpinnerContainer;
    const bindingObject: any = isObject(binding.value) ? binding.value : null;
    const value = bindingObject ? bindingObject.loading : binding.value;
    const isFluid: boolean = bindingObject ? bindingObject.fluid : binding.modifiers.fluid;
    let size = bindingObject ? bindingObject.size : null;

    if (binding.modifiers.large) {

        size = 'large';
    }
    else if (binding.modifiers.medium) {

        size = 'medium';
    }
    else if (binding.modifiers.small) {

        size = 'small';
    }

    // Store timeout ID in element's dataset
    const timeoutKey = 'spinnerTimeout';

    if (value) {

        // Clear any existing timeout
        if (el.dataset[timeoutKey]) {
            window.clearTimeout(Number(el.dataset[timeoutKey]));
        }

        // Set new timeout
        el.dataset[timeoutKey] = window.setTimeout(
            () => {

                if (!containerClass) {
                    containerClass = insertSpinner(el, isFluid, size);
                }

                const containerContainer = containerClass ? el.querySelector(`.${containerClass}`) : null;
                const container = containerClass ? el.querySelector(`.${containerClass} .ui-spinner`) : null;
                if (!container) return;

                if (!el.classList.contains('has-spinner')) {
                    el.classList.add('has-spinner');
                }

                if (!isFluid && !el.classList.contains('spinner-fill')) {
                    el.classList.add('spinner-fill');
                }

                containerContainer.classList.remove("hide-spinner");
                container.classList.add('visible');
            },
            binding.modifiers.instant ? 0 : 75
        ).toString();
    }
    else {

        // Clear timeout if value becomes false
        if (el.dataset[timeoutKey]) {
            window.clearTimeout(Number(el.dataset[timeoutKey]));
            delete el.dataset[timeoutKey];
        }

        // Hide spinner immediately
        const containerContainer = containerClass ? el.querySelector(`.${containerClass}`) : null;
        const container = containerClass ? el.querySelector(`.${containerClass} .ui-spinner`) : null;

        if (container) {

            containerContainer.classList.add("hide-spinner");
            container.classList.remove('visible');
        }
    }
}

function insertSpinner(el: HTMLElement, fluid: boolean, size: string) {

    const containerClass = 'ui-spinner-' + uuid();

    const spinnerEl = document.createElement('div');
    el.appendChild(spinnerEl);

    const spinner = createApp(Spinner, {
        size,
        overlay: true
    });

    spinner.mount(spinnerEl);

    spinnerEl.classList.add(containerClass);

    el.classList.add('has-spinner');

    if (!fluid) {
        el.classList.add('spinner-fill');
    }

    el.dataset.uiSpinnerContainer = containerClass;

    return containerClass;
}

export const spinnerDirective: Directive = {

    mounted: update,
    updated: update
};

export default spinnerDirective;
